<div class="layout-topbar">
    <a href="#" id="layout-menu-btn" class="menu-btn" (click)="app.onMenuButtonClick($event)">
        <i class="pi pi-bars"></i>
    </a>
    <span class="text-2xl text-700 line-height-5" style="letter-spacing: 1px;">{{(appComp.switchApp |
        async).text}}</span>
    <div class="layout-topbar-menu-wrapper">
        <ul class="topbar-menu fadeInDown" [ngClass]="{'topbar-menu-active': app.topbarMenuActive}">
            <li class="profile-item " #profile [ngClass]="{'active-topmenuitem':app.activeTopbarItem === profile}">
                <a class="flex justify-content-between align-content-center">
                    <img *ngIf="app.showHelper" src="assets/layout/images/help.svg" alt="manhattan-layout"
                        style="width: 30px; height: 30px;" />
                </a>

                <a *ngIf="auth.currentUserValue" class="flex justify-content-between align-content-center">
                    <i class="pi pi-user"></i>
                    <span class="topbar-item-name profile-name my-auto">{{
                        auth.currentUserValue?.loginTaxis?.matricula ??
                        auth.currentUserValue?.nomusu }}</span>
                </a>
                <a href="#" (click)="$event.preventDefault(); app.logout()"
                    class="flex justify-content-between align-content-center">
                    <i class="fa-solid fa-fw fa-arrow-right-from-bracket"></i>
                    <span class="my-auto">Cerrar Sesión</span>
                </a>

            </li>
        </ul>
        <a class="mr-3 pt-1 topbar-menu-btn" (click)="app.onClickHelp()">
            <img *ngIf="app.showHelper" src="assets/layout/images/help.svg" alt="manhattan-layout"
                style="width: 30px; height: 30px;" />

        </a>
        <a class="mr-3 pt-1 topbar-menu-btn" [routerLink]="['/notificaciones']">
            <img src="assets/layout/images/mensajeria/campana.svg" alt="manhattan-layout"
                [ngClass]="checkNotificacions() ? '' : 'grayscale' " style="width: 30px; height: 30px;" pBadge
                [value]="notificaciones.length" />

        </a>
        <a class="topbar-menu-btn" (click)="app.onTopbarMenuButtonClick($event)">
            <img src="assets/layout/images/avatar.png" alt="manhattan-layout" />
        </a>

    </div>
</div>

<div *ngIf="!app.nopadd" class="absolute w-full h-2rem bg-bluegray-50 pl-4 py-1 font-medium text-700" style="top:64px">
    {{bedcum | async | uppercase}}
</div>
